module.exports = __webpack_public_path__ + "static/media/hot_info.6d3f92c3.svg";